<template>
  <div class="admin-content">
    <div class="detail">
      <div class="hd">
        <h2 class="title">销售统计</h2>
      </div>
      <div class="bd">
        <ul class="detail-list">
          <li v-for="(item, index) in detailOption" v-if="get(walletData, item.value) !== undefined" :key="index" :class="item.className" v-show="!(item.showFn && item.showFn(get(walletData, item.value)))">
            <div class="title">{{item.label}}</div>
            <div class="content">
              <template v-if="item.computed">
                {{item.computed(get(walletData, item.value))}}
              </template>
              <template v-else>
                {{get(walletData, item.value)}}元
              </template>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!--列表-->
    <app-list :filter="listOption.filter" :remote="listOption.remote" :table-head="listOption.tableHead" :table-code="listOption.tableCode" ref="list"></app-list>
  </div>
</template>
<script>
import { getVolumeList, getUserWallet } from '@/api/admin'
import List from '@/views/admin/common/list'
import get from 'lodash.get'

export default {
  components: { 'app-list': List },
  data() {
    return {
      walletData: null,
      // 列表配置
      listOption: {
        filter: [
          {
            type: 'select',
            labelName: '场景',
            key: 'sceneType',
            value: null,
            placeholder: '请选择',
            options: [
              { label: '不限', value: null },
              { label: '线下', value: 'OFFLINE' }
            ]
          },
          {
            type: 'datePicker',
            labelName: '开始时间',
            key: 'startTime',
            value: '',
            placeholder: '请选择',
            props: { editable: false, clearable: true, type: 'datetime' }
          },
          {
            type: 'datePicker',
            labelName: '结束时间',
            key: 'endTime',
            value: '',
            placeholder: '请选择',
            props: { editable: false, clearable: true, type: 'datetime' }
          },
          {
            type: 'button',
            isSearch: true,
            value: '搜索'
          }
        ],
        remote: {
          fetch: getVolumeList,
          param: {
            sceneType: null,
            page: {
              index: 1,
              size: 10
            }
          }
        },
        tableHead: [
          {
            name: '商品名',
            code: 'name'
          },
          {
            name: '具体商品',
            code: 'name1'
          },
          {
            name: '当日销售数量',
            code: 'dayCount'
          },
          {
            name: '总销售数量',
            code: 'sellCount'
          },
          {
            name: '当日使用量',
            code: 'useCount'
          },
          {
            name: '总使用量',
            code: 'allUseCount'
          }
        ]
      },
      detailOption: [{ label: '当前账户金额：', value: 'cashBalance' }]
    }
  },
  methods: {
    get,
    getUserWallet() {
      getUserWallet().then(response => {
        this.walletData = response.data
      })
    }
  },
  created() {
    this.getUserWallet()
  }
}
</script>
